// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { emptyGuid } from "@insite/client-framework/Common/StringHelpers";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { setMainNavigation } from "@insite/client-framework/Components/ShellHoleConnect";
import Logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    getCategoriesDataView,
    getCategoryDepthLoaded,
    getCategoryState,
    getSubCategoryIds,
} from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import loadCategories from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategories";
import loadCategory from "@insite/client-framework/Store/Data/Categories/Handlers/LoadCategory";
import { getPageLinkByNodeId, getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { StylesContext } from "@insite/content-library/additionalStyles";
// import MainNavigationItem from "@insite/content-library/Components/MainNavigationItem"; // Starter Custom Code
// import NavigationDrawer from "@insite/content-library/Components/NavigationDrawer"; // Starter Custom Code
import { NavigationModeCookieName } from "@insite/content-library/Components/NavigationModeMenu";
// import SearchInput, { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput"; // Starter Custom Code
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import Hidden from "@insite/mobius/Hidden";
// import { IconProps } from "@insite/mobius/Icon"; // Starter Custom Code
// import Search from "@insite/mobius/Icons/Search"; // Starter Custom Code
import X from "@insite/mobius/Icons/X";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import { MenuPresentationProps } from "@insite/mobius/Menu";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { PopoverPresentationProps, PositionStyle } from "@insite/mobius/Popover";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { resolveColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
// eslint-disable-next-line spire/fenced-imports
import { TS } from "@insite/shell/TS";
import * as cssLinter from "css";
import isEqual from "lodash/isEqual";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Zone from "@insite/client-framework/Components/Zone";
import { getHeader } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ClickableProps } from "@insite/mobius/Clickable";
import { IconProps, IconWrapper } from "@insite/mobius/Icon";
import constants from "@store/constants";
import ArrowForward from "@store/Library/Components/Toolkit/Icons/ArrowForward";
import ChevronDown, { ChevronDownOffset } from "@store/Library/Components/Toolkit/Icons/ChevronDown";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import Search from "@store/Library/Components/Toolkit/Icons/Search";
import { sizedWrapperImageStyles } from "@store/Library/Components/Toolkit/SizedWrapper";
import MainNavigationItem from "@store/Overrides/Components/MainNavigationItem";
import NavigationDrawer from "@store/Overrides/Components/NavigationDrawer";
import { getShowNavigationModeMenu } from "@store/Overrides/Components/NavigationModeMenu";
import SearchInput, { SearchInputStyles } from "@store/Overrides/Widgets/Header/SearchInput";
import {
    headerHideForDesktopStyles,
    headerHideForMobileStyles,
    headerMobileSelector,
} from "@store/Themes/common/mixins/header";
import { linkActionStyles, linkAltStyles, linkStyles } from "@store/Themes/common/mixins/link";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import {
    focusStyles,
    gridGapStyles,
    iconColorStyles,
    siteWidthStyles,
    spacingStyles,
} from "@toolkit/Themes/common/mixins";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import { LazyImageProps } from "@insite/mobius/LazyImage";
/* Store Custom Code - End */

const popoverContentPadding = pxToRem(16);

const megaMenuPopoverProps: PopoverPresentationProps = {
    transitionDuration: "short",
    wrapperProps: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    contentBodyProps: {
        _height: "calc(90vh - 200px)", // Setup view height minus approximate header size
        css: css`
            top: 100%;
            right: 0;
            left: 0;
            box-shadow: ${x => x.theme.shadows.e80};
            transition: none;
        `,
    },
};

const megaMenuWithTabsMainChildStyles = () => {
    return css`
        ${x => breakpointValues(x.theme.design.menu.megaMenuWithTabs.tabs.width, "width")}

        ${({ theme }) => {
            if (!theme.design.menu.mainNavigation.megaMenuFullWidth) {
                return css`
                    padding-left: ${theme.design.menu.megaMenuWithTabs.tabs.spacingLeft};
                `;
            }
        }}
    `;
};

const megaMenuWithTabsMainChildLinkStyles = (hoverUnderline = false) => {
    return css`
        ${linkStyles("text.linkAlt", "text.linkAltHover", false, hoverUnderline)}
        ${focusStyles(true)}
        align-items: center;
        width: 100%;
        padding: ${x => x.theme.design.menu.megaMenuWithTabs.tabs.childSpacing};
        font-weight: ${x => x.theme.design.typography.weight.bold};
        line-height: ${x => x.theme.design.typography.lineHeight.semi};
        /* Store Custom Code - Start */
        &:hover,
        &[aria-expanded="true"] {
            font-weight: ${x => x.theme.design.typography.weight.bold};
        }
        /* Store Custom Code - End */
    `;
};

const megaMenuViewAllLinkProps = (isMegaMenuWithTabs = false) => {
    /* Store Custom Code - Start */
    return {
        css: css`
            ${linkStyles(
                !isMegaMenuWithTabs ? "text.link" : "secondary.dark",
                !isMegaMenuWithTabs ? "text.linkHover" : "secondary.dark",
                true,
                false,
            )}
            font-weight: ${x => x.theme.design.typography.weight.base};
            width: ${x => (isMegaMenuWithTabs ? "100%" : null)};
            padding: ${x => (isMegaMenuWithTabs ? x.theme.design.menu.megaMenuWithTabs.tabs.childSpacing : 0)};
        `,
    };
    /* Store Custom Code - End */
};

const handleFolderLink = (link: MappedLink) => {
    link = { ...link };

    if (link.children && link.children.length) {
        link.children = link.children.map(x => handleFolderLink(x));
    }

    if (link.type === constants.pageType.folder) {
        link.url = "";
        link.excludeFromNavigation = !link.children?.some(x => !x.excludeFromNavigation);
    }

    return link;
};
/* Starter Custom Code - End */

const enum fields {
    links = "links",
    showQuickOrder = "showQuickOrder",
    openParentPages = "openParentPages",
    customCSS = "customCSS",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.links]: LinkModel[];
        [fields.showQuickOrder]: boolean;
        [fields.openParentPages]: boolean;
        [fields.customCSS]: string;
    };
    isCompactHeaderFlyoutMenu: boolean;
    flyoutCustomCSS?: string;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    isCompactHeaderMainNavigation: boolean;
    сompactHeaderMainNavigationCustomCSS?: string;
}

interface LinkModel {
    fields: {
        openInNewWindow: boolean;
        destination: LinkFieldValue;
        linkType: "Link" | "MegaMenu" | "CascadingMenu" | "CustomLinkList";
        overrideTitle: string;
        title: string;
        numberOfColumns: number;
        maxDepth: number;
        childLinks?: LinkModel[];
        titleLink?: LinkFieldValue;
        parentTitle?: string;
        // Starter Custom Code
        maxChild?: number;
        maxChildren?: number;
        maxGrandChildren?: number;
        isMegaMenuWithTabs?: boolean;
        numberOfColumnsMegaMenuWithTabs?: number;
        useOnHover?: boolean;
    };
}

export interface MappedLink {
    title: string;
    url: string;
    type?: string;
    excludeFromNavigation?: boolean;
    openInNewWindow?: boolean;
    numberOfColumns?: number;
    maxDepth?: number;
    childrenType?: "MegaMenu" | "CascadingMenu" | "CustomLinkList";
    children?: MappedLink[];
    // Starter Custom Code
    maxChild?: number;
    maxChildren?: number;
    maxGrandChildren?: number;
    isMegaMenuWithTabs?: boolean;
    numberOfColumnsMegaMenuWithTabs?: number;
    useOnHover?: boolean;
    clickableProps?: ClickableProps;
    // Store Custom Code
    smallImagePath?: string;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { links = [] },
    } = ownProps;
    const mappedLinks = [];
    const categoryIdsToLoad: Dictionary<number> = {};

    for (const link of links) {
        const mappedLink = mapLink(link, state, categoryIdsToLoad);
        if (!mappedLink) {
            continue;
        }
        mappedLinks.push(mappedLink);
    }
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const { orderSettings } = getSettingsCollection(state);
    const session = getSession(state);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const isVmiAdmin = session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1;
    const isVmiUser = session.userRoles?.toLowerCase().indexOf("vmi_user") !== -1;
    return {
        links: mappedLinks,
        quickOrderLink: getPageLinkByPageType(state, "QuickOrderPage"),
        categoryIdsToLoad,
        allowQuickOrder: orderSettings.allowQuickOrder,
        categoryErrorStatusCodeById: state.data.categories.errorStatusCodeById,
        categoryIdsCalled: state.data.categories.categoryIdsCalled,
        displayChangeCustomerLink: session?.displayChangeCustomerLink,
        displayVmiNavigation:
            currentMode === "Vmi" && orderSettings.vmiEnabled && isAuthenticated && (isVmiAdmin || isVmiUser),
        displayModeSwitch: getShowNavigationModeMenu(state), // Starter Custom Code
        currentMode,
        vmiPageLinks: isVmiAdmin
            ? [
                  getPageLinkByPageType(state, "VmiDashboardPage"),
                  getPageLinkByPageType(state, "VmiLocationsPage"),
                  getPageLinkByPageType(state, "VmiUsersPage"),
                  getPageLinkByPageType(state, "VmiBinsPage"),
                  getPageLinkByPageType(state, "VmiReportingPage"),
                  getPageLinkByPageType(state, "VmiOrderHistoryPage"),
              ]
            : isVmiUser
              ? [
                    getPageLinkByPageType(state, "VmiDashboardPage"),
                    getPageLinkByPageType(state, "VmiLocationsPage"),
                    getPageLinkByPageType(state, "VmiBinsPage"),
                    getPageLinkByPageType(state, "VmiReportingPage"),
                    getPageLinkByPageType(state, "VmiOrderHistoryPage"),
                ]
              : [],
        // Starter Custom Code
        headerId: getHeader(state).id || ownProps.id,
    };
};

const mapLink = (
    link: LinkModel,
    state: ApplicationState,
    categoryIdsToLoad: Dictionary<number>,
    isChildLink = false,
) => {
    const {
        fields: {
            linkType,
            destination,
            openInNewWindow,
            overrideTitle: overrideTitleValue,
            numberOfColumns,
            maxDepth,
            title: titleValue,
            childLinks,
            parentTitle,
            titleLink,
            // Starter Custom Code
            maxChild,
            maxChildren,
            maxGrandChildren,
            isMegaMenuWithTabs,
            numberOfColumnsMegaMenuWithTabs,
            useOnHover,
        },
    } = link;
    const { type: typeValue, value: destinationValue } = destination;

    let type = typeValue;
    let value = destinationValue;
    let title = titleValue;
    let overrideTitle = overrideTitleValue;
    if (linkType === "CustomLinkList") {
        type = titleLink?.type ?? "Page";
        value = titleLink?.value ?? "";
        title = parentTitle ?? "";
        overrideTitle = parentTitle ?? "";
    }

    const depthToLoad =
        linkType === "MegaMenu"
            ? !isMegaMenuWithTabs
                ? 3
                : 4
            : linkType === "CustomLinkList" || isChildLink
              ? 0
              : maxDepth; // Starter Custom Code

    let mappedLink: MappedLink | undefined;

    if (type === "Url") {
        mappedLink = {
            url: value,
            title: isChildLink ? overrideTitle : title,
        };
    } else if (type === "Page") {
        const readonlyPageLink = getPageLinkByNodeId(state, value);
        if (readonlyPageLink) {
            mappedLink = { ...readonlyPageLink };
            if (overrideTitle) {
                mappedLink.title = overrideTitle;
            }
        }
    } else if (type === "Category") {
        mappedLink = setupCategoryLink(
            state,
            value,
            categoryIdsToLoad,
            depthToLoad,
            overrideTitle,
            state.data.categories.categoryIdsCalled,
        );
    }

    if (linkType === "CustomLinkList") {
        if (!mappedLink) {
            mappedLink = {
                title: parentTitle ?? title,
                url: "",
                excludeFromNavigation: false,
                childrenType: "CustomLinkList",
            };
        }
        let mappedChildren: MappedLink[] = [];
        if (childLinks && childLinks.length > 0) {
            for (const child of childLinks) {
                const childLink = mapLink(child, state, categoryIdsToLoad, true);
                if (childLink) {
                    mappedChildren.push(childLink);
                }
            }
        }
        mappedLink.children = mappedChildren;
    }

    if (!mappedLink) {
        return;
    }

    mappedLink.openInNewWindow = openInNewWindow;
    mappedLink.numberOfColumns = isMegaMenuWithTabs ? numberOfColumnsMegaMenuWithTabs : numberOfColumns; // Starter Custom Code
    mappedLink.maxDepth = maxDepth;
    mappedLink.excludeFromNavigation =
        linkType === "CustomLinkList" || isChildLink ? false : mappedLink.excludeFromNavigation;
    /* Starter Custom Code - Start */
    mappedLink.maxChild = maxChild;
    mappedLink.maxChildren = maxChildren;
    mappedLink.maxGrandChildren = maxGrandChildren;
    mappedLink.isMegaMenuWithTabs = isMegaMenuWithTabs;
    mappedLink.useOnHover = useOnHover;
    /* Starter Custom Code - End */

    if (linkType === "MegaMenu" || linkType === "CascadingMenu" || linkType === "CustomLinkList") {
        mappedLink.childrenType = linkType;
    }
    mappedLink = handleFolderLink(mappedLink); // Starter Custom Code

    return mappedLink;
};

const getParameter = (categoryId: string, maxDepth: number) => ({
    maxDepth,
    startCategoryId: categoryId === emptyGuid ? undefined : categoryId,
    includeStartCategory: categoryId !== emptyGuid,
});

const setupCategoryLink = (
    state: ApplicationState,
    value: string,
    categoryIdsToLoad: Dictionary<number>,
    maxDepth: number,
    overrideTitle: string,
    categoryIdsCalled: string[],
) => {
    let mappedLink: MappedLink | undefined;

    if (!value) {
        return;
    }

    const depthLoaded = getCategoryDepthLoaded(state, value);
    const subCategoryIds = getSubCategoryIds(state, value);
    if (
        (depthLoaded < maxDepth || (!subCategoryIds && !categoryIdsCalled?.includes(value))) &&
        !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
    ) {
        categoryIdsToLoad[value] = maxDepth;
    } else {
        if (value === emptyGuid) {
            mappedLink = {
                url: "",
                title: overrideTitle || translate("Products"),
            };
        } else {
            const categoryState = getCategoryState(state, value);
            if (!categoryState.value) {
                if (
                    !categoryState.isLoading &&
                    !getCategoriesDataView(state, getParameter(value, maxDepth)).isLoading
                ) {
                    categoryIdsToLoad[value] = maxDepth;
                }
                return;
            }
            mappedLink = {
                url: categoryState.value.path,
                title: overrideTitle || categoryState.value.shortDescription,
            };
        }

        loadSubCategories(mappedLink, subCategoryIds, 1, maxDepth, state);
    }

    return mappedLink;
};

const loadSubCategories = (
    mappedLink: MappedLink,
    subCategoryIds: readonly string[] | undefined,
    currentDepth: number,
    maxDepth: number,
    state: ApplicationState,
) => {
    if (currentDepth > maxDepth) {
        return;
    }
    mappedLink.children = [];
    if (!subCategoryIds) {
        return;
    }
    for (const subCategoryId of subCategoryIds) {
        const subCategory = getCategoryState(state, subCategoryId).value;
        if (!subCategory) {
            Logger.error(`Category ${subCategoryId} was not found in data state, excluding from navigation.`);
            continue;
        }
        const childLink: MappedLink = {
            url: subCategory.path,
            title: subCategory.shortDescription,
            children: [],
            smallImagePath: subCategory.smallImagePath ?? subCategory.largeImagePath /* Store Custom Code */,
        };
        mappedLink.children.push(childLink);

        loadSubCategories(childLink, subCategory.subCategoryIds, currentDepth + 1, maxDepth, state);
    }
};

const mapDispatchToProps = {
    loadCategories,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface State {
    selectedLinkIndex?: number;
    mobileSearchModalIsOpen: boolean;
}

export interface MainNavigationStyles {
    menuHeight: number;
    container?: InjectableCss;
    itemWrapper?: InjectableCss;
    quickOrderItemWrapper?: InjectableCss;
    menuItem?: InjectableCss;
    menuItemIcon?: IconProps;
    menuItemTypography?: TypographyPresentationProps;
    cascadingMenu?: MenuPresentationProps;
    megaMenu?: PopoverPresentationProps;
    megaMenuGridContainer?: GridContainerProps;
    megaMenuGridItem?: GridItemProps;
    megaMenuHeading?: LinkPresentationProps;
    megaMenuLink?: LinkPresentationProps;
    mobileWrapper?: InjectableCss;
    compactFlyoutMenu?: InjectableCss;
    mobileMenuWrapper?: InjectableCss;
    mobileSearchButton?: ButtonPresentationProps;
    mobileSearchWrapper?: InjectableCss;
    mobileSearchModal?: ModalPresentationProps;
    mobileSearchInputWrapper?: InjectableCss;
    mobileSearchInputStyles?: SearchInputStyles;
    mobileSearchModalCloseIcon?: IconProps;
    // Starter Custom Code
    mainWrapper?: InjectableCss;
    desktopWrapper?: InjectableCss;
    desktopInnerWrapper?: InjectableCss;
    megaMenuContentWrapper?: InjectableCss;
    megaMenuViewAllLink?: LinkPresentationProps;
    megaMenuSeeMoreLink?: LinkPresentationProps;
    megaMenuChildren?: InjectableCss;
    mobileLogoWrapper?: InjectableCss;
    megaMenuWithTabs?: PopoverPresentationProps;
    megaMenuWithTabsContentWrapper?: InjectableCss;
    megaMenuWithTabsWrapper?: InjectableCss;
    megaMenuWithTabsMainChild?: InjectableCss;
    megaMenuWithTabsMainChildLink?: LinkPresentationProps;
    megaMenuWithTabsMainChildWithSubmenuLink?: LinkPresentationProps;
    megaMenuWithTabsGridContainer?: GridContainerProps;
    megaMenuWithTabsViewAllWrapper?: InjectableCss;
    megaMenuWithTabsViewAllLink?: LinkPresentationProps;
    // Store Custom Code
    categoryImageWrapper?: InjectableCss;
    categoryImage?: LazyImageProps;
}

export const mainNavigationStyles: MainNavigationStyles = {
    menuHeight: 0, // Starter Custom - Not Needed
    mainWrapper: {
        css: css`
            display: flex;
            max-height: inherit;
        `,
    },
    desktopWrapper: {
        css: css`
            ${headerHideForMobileStyles()}
            width: 100%;
            background-color: ${getColor("menu.mainNavigation")};
            color: ${getColor("menu.mainNavigation.contrast")};
            transform: translateZ(0);
            /* Store Custom Code - Start */
            border-top: 1px solid ${getColor("common.border")};
            border-bottom: 1px solid ${getColor("common.border")};
            /* Store Custom Code - End */

            &::after {
                content: "";
                display: block;
                position: absolute;
                bottom: -1px; /* Store Custom Code */
                z-index: 1300; /* Store Custom Code */
                width: 100%;
                height: ${pxToRem(1)};
                background-color: ${getColor("common.border")}; /* Store Custom Code */
            }
        `,
    },
    desktopInnerWrapper: {
        css: siteWidthStyles(),
    },
    container: {
        css: css`
            display: flex;
            flex-flow: row wrap;
            justify-content: left;
            column-gap: 0; /* Store Custom Code */

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.small};
                ${!theme.design.menu.mainNavigation.megaMenuFullWidth ? "transform: translateZ(0);" : null}
                /* Store Removed - responsive column-gap */

                ${breakpoint("lg")} {
                    font-size: ${theme.design.typography.size.base};
                }
            `}
        `,
    },
    menuItem: {
        css: css`
            ${focusStyles(true)}
            ${x => breakpointValues(x.theme.design.menu.mainNavigation.height, "height")}
            color: inherit;
            /* Store Removed - border-bottom */
            border-left: 0;
            border-right: 0;
            transition: ${transitionHoverStyles("color", "border-color")};
            padding-right: 1em; /* Store Custom Code */
            padding-left: 1em; /* Store Custom Code */

            &:hover,
            &[aria-expanded="true"] {
                color: ${getColor("menu.mainNavigation.hover")};
                background: ${getColor("common.accent")}; /* Store Custom Code */
                /* Store Removed Code - border-bottom-color */

                ${IconWrapper} {
                    ${iconColorStyles("menu.mainNavigation.accentHover")}
                }
            }

            &[aria-expanded="true"] {
                color: ${getColor("menu.mainNavigation.hover")};
                /* Store Removed Code - border-bottom-color */
            }
        `,
    },
    menuItemIcon: {
        src: ChevronDown,
        css: css`
            ${iconScalableStyles("1.125em", ChevronDownOffset)}
            ${iconColorStyles("menu.mainNavigation.accent")}
            margin-left: 0.6em;
        `,
    },
    menuItemTypography: {
        forwardAs: "span",
        css: css`
            display: flex;
            align-items: center;
            font-weight: ${x => x.theme.design.typography.weight.base}; /* Store Custom Code */
            text-transform: uppercase;
        `,
    },
    megaMenu: megaMenuPopoverProps,
    megaMenuContentWrapper: {
        css: css`
            ${siteWidthStyles()}
            padding-top: ${pxToRem(40)};
            padding-bottom: ${pxToRem(40)};
        `,
    },
    megaMenuGridContainer: {
        gap: 0,
        css: gridGapStyles(pxToRemArray([30]), pxToRemArray([36])),
    },
    megaMenuGridItem: {
        as: "li",
        css: css`
            flex-direction: column;
        `,
    },
    megaMenuHeading: {
        css: css`
            ${linkStyles("text.link", "text.linkHover", false, true)} /* Store Custom Code */
            ${spacingStyles(null, pxToRem(12))};
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
        // Store Custom Code
        typographyProps: {
            css: css`
                display: flex;
                align-items: center;
                width: 100%;
            `,
        },
    },
    megaMenuChildren: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(4)};
            width: 100%;
        `,
    },
    megaMenuLink: {
        css: css`
            ${linkAltStyles()}
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    megaMenuSeeMoreLink: {
        css: css`
            /* Store Removed linkActionStyles() */
            ${linkStyles("text.link", "text.linkHover", true, true)} /* Store Custom Code */
            margin-top: ${pxToRem(4)};
        `,
    },
    megaMenuViewAllLink: megaMenuViewAllLinkProps(),
    megaMenuWithTabs: mergeProps<MainNavigationStyles["megaMenuWithTabs"]>(megaMenuPopoverProps, {
        contentBodyProps: {
            css: css`
                ${({ theme }) => {
                    if (theme.design.menu.mainNavigation.megaMenuFullWidth) {
                        return css`
                            background: linear-gradient(
                                to right,
                                ${theme.colors.menu.megaMenuWithTabs.tabsBackground} 0%,
                                ${theme.colors.menu.megaMenuWithTabs.tabsBackground} 50%,
                                ${theme.colors.menu.mainNavigation.main} 50%,
                                ${theme.colors.menu.mainNavigation.main} 100%
                            );
                        `;
                    }
                }}
            `,
        },
    }),
    megaMenuWithTabsContentWrapper: {
        css: css`
            ${x => siteWidthStyles(!x.theme.design.menu.mainNavigation.megaMenuFullWidth ? ["0"] : undefined)}
        `,
    },
    megaMenuWithTabsWrapper: {
        css: css`
            position: relative;
            display: flex;
            flex-direction: column;
            min-height: ${x => x.theme.design.menu.megaMenuWithTabs.minHeight};
            background-color: ${getColor("menu.megaMenuWithTabs.tabsBackground")};
        `,
    },
    megaMenuWithTabsMainChild: {
        css: css`
            ${megaMenuWithTabsMainChildStyles()}/* Store Removed - first-child */
            /* Store Removed - last-child */
        `,
    },
    megaMenuWithTabsMainChildLink: {
        css: css`
            ${megaMenuWithTabsMainChildLinkStyles()} /* Store Custom Code */

            /* Store Custom Code - Start */
            &:hover,
            &[aria-expanded="true"] {
                background-color: ${getColor("menu.megaMenuWithTabs.tabsBackgroundHover")};
                color: ${getColor("menu.mainNavigation.accentHover")};
            }
            /* Store Custom Code - End */
        `,
    },
    megaMenuWithTabsMainChildWithSubmenuLink: mergeProps<
        MainNavigationStyles["megaMenuWithTabsMainChildWithSubmenuLink"]
    >(linkGetActionLinkProps(ChevronRight, "right", "1.2em"), {
        css: css`
            ${megaMenuWithTabsMainChildLinkStyles()}
            justify-content: space-between;
            font-size: inherit;

            ${IconWrapper} {
                ${iconColorStyles("menu.mainNavigation.accentHover")}
            }

            &:hover,
            &[aria-expanded="true"] {
                background-color: ${getColor("menu.megaMenuWithTabs.tabsBackgroundHover")};
                color: ${getColor("menu.mainNavigation.accentHover")};
            }
        `,
    }),
    megaMenuWithTabsViewAllWrapper: {
        css: css`
            ${megaMenuWithTabsMainChildStyles()}
            padding-bottom: ${x => x.theme.design.menu.megaMenuWithTabs.spacing};
            margin-top: auto;
        `,
    },
    megaMenuWithTabsViewAllLink: megaMenuViewAllLinkProps(true),
    megaMenuWithTabsGridContainer: {
        as: "nav",
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([30]), pxToRemArray([36]))}
            position: absolute;
            ${x => breakpointValues(x.theme.design.menu.megaMenuWithTabs.tabs.width, "left")}
            top: 0;
            height: 100%;
            overflow-y: auto;
            padding: ${x => x.theme.design.menu.megaMenuWithTabs.tabsContent.spacing};
            background-color: ${getColor("menu.mainNavigation")};

            ${({ theme }) => {
                return css`
                    ${breakpointValues(
                        theme.design.menu.megaMenuWithTabs.tabs.width.map(x => {
                            if (!x) {
                                return null;
                            }

                            return css`
                                width: calc(100% - ${x});
                            `;
                        }),
                    )}
                `;
            }}
        `,
    },
    mobileWrapper: {
        css: css`
            ${headerHideForDesktopStyles()}
            display: flex;
            align-items: center;
            flex-grow: 1;
            max-height: inherit;
            ${x => breakpointValues(x.theme.design.header.itemSpacing, "column-gap")}
        `,
    },
    mobileLogoWrapper: {
        css: css`
            ${sizedWrapperImageStyles()}
            ${x => breakpointValues(x.theme.design.header.iconButton.padding, ["padding-right", "padding-left"])}
            flex-grow: 1;

            /* Store Custom Code - Start */
            img {
                height: ${pxToRem(33)};
            }
            /* Store Custom Code - End */
        `,
    },
    mobileSearchButton: headerIconButtonProps,
    mobileSearchModal: {
        cssOverrides: {
            modalTitle: css`
                ${x => x.theme.modal?.defaultProps?.cssOverrides?.modalTitle}
                border: none;
            `,
            modalContent: css`
                ${x => x.theme.modal?.defaultProps?.cssOverrides?.modalContent}
                height: 100%;
                overflow: hidden;
                padding: ${pxToRem(6)} 0 0 0 !important;
            `,
            modalBody: css`
                ${x => x.theme.modal?.defaultProps?.cssOverrides?.modalBody}
                height: 100% !important;

                ${headerMobileSelector()} {
                    margin: 0;
                    max-height: 100%;
                    max-width: 100%;
                }
            `,
        },
    },
    mobileSearchInputStyles: {
        popoverWrapper: {
            css: css`
                display: flex;
                flex-direction: column;
                height: 100%;
            `,
        },
        popoverContentBody: {
            css: css`
                position: static !important;
                overflow: hidden;
                transform: none;
            `,
        },
        popoverContentWrapper: {
            css: css`
                height: 100%;
                padding: ${popoverContentPadding} 0;
            `,
        },
        input: {
            cssOverrides: {
                formField: css`
                    padding: 0 ${popoverContentPadding};
                `,
            },
        },
        autocompleteWrapper: {
            css: css`
                flex-wrap: wrap;
            `,
        },
    },
    // Store Custom Code
    categoryImageWrapper: {
        css: css`
            margin-right: 1em;
            height: ${pxToRem(60)};
            width: ${pxToRem(60)};
        `,
    },
    categoryImage: {
        width: pxToRem(60),
        height: pxToRem(60),
    },
};

/* Starter Custom Code - Start */
const defaultCustomCss = `.mobile-wrapper {
}

.mobile-menu-wrapper {
}

.menu-trigger-button {
}

.menu-trigger-button-icon {
}

.drawer {
}

.drawer-section-wrapper {
}

.currency-selector-wrapper {
}

.language-selector-wrapper {
}

.drawer-secondary-section-wrapper {
}

.panel-menu {
}

.main-row {
}

.panel-section-wrapper {
}

.main-row-icon {
}

.main-row-label {
}

.main-row-value {
}

.main-row-text {
}

.secondary-row {
}

.secondary-row-icon {
}

.secondary-row-text {
}

.language-image {
}

.change-customer-row {
}

.change-customer-row-container {
}

.fulfillment-method-grid-item {
}

.addresses-grid-item {
}

.pick-up-address-grid-item {
}

.mobile-logo-wrapper {
}

.mobile-search-wrapper {
}

.mobile-search-button {
}

.mobile-search-button-icon {
}

.container {
}

.item-wrapper {
}

.cascading-menu {
}

.menu-item {
}

.mega-menu {
}

.mega-menu-grid-container {
}

.mega-menu-grid-item {
}

.mega-menu-heading-link {
}

.mega-menu-link {
}

.mega-menu-more-link {
}

.quick-order-item-wrapper {
}

.quick-order-link {
}

.vmi-page-link {
}

.mobile-search-modal {
}`;
/* Starter Custom Code - End */

export class MainNavigation extends React.Component<Props, State> {
    container = React.createRef<HTMLUListElement /* Starter Custom Code */ | null>();
    mobileSearchInput = React.createRef<HTMLInputElement>();
    declare context: React.ContextType<typeof StylesContext>;

    constructor(props: Props) {
        super(props);

        this.state = {
            mobileSearchModalIsOpen: false,
        };
    }

    UNSAFE_componentWillMount(): void {
        this.loadCategoriesIfNeeded();

        setMainNavigation({
            close: () => {
                this.setState({
                    selectedLinkIndex: undefined,
                });
            },
            openMenu: (index: number) => {
                this.setState({
                    selectedLinkIndex: index,
                });
            },
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
        if (!isEqual(this.props.categoryIdsToLoad, prevProps.categoryIdsToLoad)) {
            this.loadCategoriesIfNeeded(true);
        }
    }

    loadCategoriesIfNeeded(isComponentDidUpdate = false) {
        const { categoryIdsToLoad } = this.props;
        for (const categoryId of Object.keys(categoryIdsToLoad)) {
            if (!this.props.categoryErrorStatusCodeById?.[categoryId]) {
                const maxDepth = categoryIdsToLoad[categoryId];
                if (!this.props.categoryIdsCalled?.includes(categoryId) || isComponentDidUpdate) {
                    this.props.loadCategories(getParameter(categoryId, maxDepth));
                }
            }
        }
    }

    getMobileSearchAutocompletePosition = (element: React.RefObject<HTMLUListElement | null>) => {
        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            positionStyle.top = rect.top + rect.height;
            positionStyle.left = 0;
            positionStyle.width = `${document.documentElement.clientWidth}px`;
            positionStyle.height = `${document.documentElement.clientHeight - positionStyle.top}px`;
        }

        return positionStyle;
    };

    mobileSearchButtonClickHandler = () => {
        this.setState({ mobileSearchModalIsOpen: true }, () => {
            setTimeout(() => {
                if (this.mobileSearchInput?.current) {
                    this.mobileSearchInput.current.focus();
                    this.mobileSearchInput.current.click();
                }
            }, 250);
        });
    };

    mobileSearchModalCloseHandler = () => {
        this.setState({ mobileSearchModalIsOpen: false });
    };

    render() {
        const {
            links,
            quickOrderLink,
            fields: { showQuickOrder, openParentPages, customCSS },
            id,
            allowQuickOrder,
            isCompactHeaderFlyoutMenu,
            flyoutCustomCSS,
            showFlyoutPricingToggle,
            showFlyoutInventoryToggle,
            isCompactHeaderMainNavigation,
            сompactHeaderMainNavigationCustomCSS,
            vmiPageLinks,
            displayVmiNavigation,
            displayModeSwitch,
            currentMode,
            // Starter Custom Code
            headerId,
        } = this.props;
        const { selectedLinkIndex } = this.state;

        const showQuickOrderLink = showQuickOrder && allowQuickOrder;
        const mainNavContextStyles = this?.context?.styles?.mainNavigation ?? {};
        const styles = mergeProps(mainNavigationStyles, mainNavContextStyles); // Starter Custom Code

        if (isCompactHeaderFlyoutMenu) {
            /* Starter Custom Code - Start */
            const flyoutCustomCssWrapper = css`
                ${styles.compactFlyoutMenu?.css}
                ${flyoutCustomCSS}
            `;
            /* Starter Custom Code - End */

            return (
                <StyledWrapper
                    className="flyout-menu-wrapper"
                    {...styles.compactFlyoutMenu}
                    // Starter Custom Code
                    css={flyoutCustomCssWrapper}
                >
                    <NavigationDrawer
                        links={links}
                        showQuickOrder={showQuickOrderLink}
                        quickOrderLink={quickOrderLink}
                        displayVmiNavigation={displayVmiNavigation}
                        vmiPageLinks={vmiPageLinks}
                        displayModeSwitch={displayModeSwitch}
                        currentMode={currentMode}
                        isCompactHeaderFlyout={true}
                        showFlyoutPricingToggle={showFlyoutPricingToggle}
                        showFlyoutInventoryToggle={showFlyoutInventoryToggle}
                        allowOpenParentLinks={openParentPages}
                        // Starter Custom Code
                        uniqueId={id}
                    />
                </StyledWrapper>
            );
        }

        if (isCompactHeaderMainNavigation) {
            /* Starter Custom Code - Start */
            const mainNavigationCustomCssWrapper = css`
                ${styles.container?.css}
                ${сompactHeaderMainNavigationCustomCSS}
            `;
            /* Starter Custom Code - End */

            return (
                <StyledWrapper
                    className="container"
                    {...styles.container}
                    ref={this.container}
                    // Starter Custom Code
                    as="ul"
                    css={mainNavigationCustomCssWrapper}
                >
                    {displayVmiNavigation &&
                        /* Starter Moved - container - up */
                        /* Starter Custom - itemWrapper moved inside map */
                        vmiPageLinks.map(
                            link =>
                                link && (
                                    <StyledWrapper
                                        className="item-wrapper"
                                        {...styles.itemWrapper}
                                        data-test-selector="vmiPageLinks"
                                        // Starter Custom Code
                                        as="li"
                                        key={link.id}
                                    >
                                        <Link
                                            className="vmi-page-link"
                                            // Starter Custom - moved key on itemWrapper
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            id={link.id}
                                            href={link.url}
                                            data-test-selector={`vmiPageLink-${link.title.replace(/\s+/g, "")}`}
                                        >
                                            {link.title}
                                        </Link>
                                    </StyledWrapper>
                                ),
                        )}
                    {!displayVmiNavigation && (
                        /* Starter Removed - StyledWrapper */
                        <>
                            {links.map((link, index) => {
                                return (
                                    <StyledWrapper
                                        className="item-wrapper"
                                        {...styles.itemWrapper}
                                        key={index}
                                        data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                        // Starter Custom Code
                                        as="li"
                                    >
                                        <MainNavigationItem
                                            index={index}
                                            link={link}
                                            styles={styles}
                                            container={this.container}
                                            isOpen={index === selectedLinkIndex}
                                            displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                        />
                                    </StyledWrapper>
                                );
                            })}
                            {showQuickOrderLink && quickOrderLink && (
                                <StyledWrapper
                                    className="item-wrapper"
                                    {...styles.itemWrapper}
                                    // Starter Custom Code
                                    as="li"
                                >
                                    <StyledWrapper
                                        className="quick-order-item-wrapper"
                                        {...styles.quickOrderItemWrapper}
                                    >
                                        <Link
                                            className="quick-order-link"
                                            typographyProps={styles.menuItemTypography}
                                            color={styles.menuItemTypography?.color}
                                            {...styles.menuItem}
                                            // Starter Removed - id
                                            href={quickOrderLink.url}
                                        >
                                            {quickOrderLink.title}
                                        </Link>
                                    </StyledWrapper>
                                </StyledWrapper>
                            )}
                        </>
                    )}
                </StyledWrapper>
            );
        }

        /* Starter Custom Code - Start */
        const customCssWrapper = css`
            ${styles.mainWrapper?.css}
            ${customCSS}
        `;
        /* Starter Custom Code - End */

        return (
            <StyledWrapper {...styles.mainWrapper} css={customCssWrapper} /* Starter Custom Code */>
                <StyledWrapper className="mobile-wrapper" {...styles.mobileWrapper}>
                    {/* Starter Custom Code - Start */}
                    <StyledWrapper className="mobile-menu-wrapper" {...styles.mobileMenuWrapper}>
                        <NavigationDrawer
                            links={links}
                            showQuickOrder={showQuickOrderLink}
                            quickOrderLink={quickOrderLink}
                            displayVmiNavigation={displayVmiNavigation}
                            vmiPageLinks={vmiPageLinks}
                            displayModeSwitch={displayModeSwitch}
                            currentMode={currentMode}
                            // Starter Removed - rootElementSelector
                            allowOpenParentLinks={openParentPages}
                            // Starter Custom Code
                            uniqueId={id}
                        />
                    </StyledWrapper>
                    <StyledWrapper className="mobile-logo-wrapper" {...styles.mobileLogoWrapper} data-zone-single>
                        <Zone contentId={headerId} zoneName="Logo" />
                    </StyledWrapper>
                    <StyledWrapper className="mobile-search-wrapper" {...styles.mobileSearchWrapper}>
                        <Button
                            className="mobile-search-button"
                            {...styles.mobileSearchButton}
                            onClick={this.mobileSearchButtonClickHandler}
                        >
                            <ButtonIcon className="mobile-search-button-icon" src={Search} />
                            <VisuallyHidden>{translate("Search")}</VisuallyHidden>
                        </Button>
                    </StyledWrapper>
                    {/* Starter Custom Code - End */}
                </StyledWrapper>
                <StyledWrapper {...styles.desktopWrapper} /* Starter Custom Code */>
                    <StyledWrapper {...styles.desktopInnerWrapper} /* Starter Custom Code */>
                        {!displayVmiNavigation && (
                            <StyledWrapper
                                className="container"
                                {...styles.container}
                                ref={this.container}
                                // Starter Custom Code
                                as="ul"
                            >
                                {links.map((link, index) => {
                                    return (
                                        <StyledWrapper
                                            className="item-wrapper"
                                            {...styles.itemWrapper}
                                            key={index}
                                            data-test-selector={`mainNavigationLink-${link.title.replace(/\s+/g, "")}`}
                                            // Starter Custom Code
                                            as="li"
                                        >
                                            <MainNavigationItem
                                                index={index}
                                                link={link}
                                                styles={styles}
                                                container={this.container}
                                                isOpen={index === selectedLinkIndex}
                                                displayChangeCustomerLink={this.props.displayChangeCustomerLink}
                                            />
                                        </StyledWrapper>
                                    );
                                })}
                                {showQuickOrderLink && quickOrderLink && (
                                    <StyledWrapper
                                        className="item-wrapper"
                                        {...styles.itemWrapper}
                                        // Starter Custom Code
                                        as="li"
                                    >
                                        <StyledWrapper
                                            className="quick-order-item-wrapper"
                                            {...styles.quickOrderItemWrapper}
                                        >
                                            <Link
                                                className="quick-order-link"
                                                typographyProps={styles.menuItemTypography}
                                                color={styles.menuItemTypography?.color}
                                                {...styles.menuItem}
                                                // Starter Removed - id
                                                href={quickOrderLink.url}
                                            >
                                                {quickOrderLink.title}
                                            </Link>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        )}
                        {displayVmiNavigation && (
                            <StyledWrapper
                                className="container"
                                {...styles.container}
                                ref={this.container}
                                // Starter Custom Code
                                as="ul"
                            >
                                {/* Starter Custom - itemWrapper moved inside map */}
                                {vmiPageLinks.map(
                                    link =>
                                        link && (
                                            <StyledWrapper
                                                className="item-wrapper"
                                                {...styles.itemWrapper}
                                                key={link.id}
                                                as="li"
                                            >
                                                <Link
                                                    className="vmi-page-link"
                                                    // Starter Custom - moved key on itemWrapper
                                                    typographyProps={styles.menuItemTypography}
                                                    color={styles.menuItemTypography?.color}
                                                    {...styles.menuItem}
                                                    id={link.id}
                                                    href={link.url}
                                                    data-test-selector={`vmiNavigation_${link.title.replace(/\s+/g, "")}`}
                                                >
                                                    {link.title}
                                                </Link>
                                            </StyledWrapper>
                                        ),
                                )}
                            </StyledWrapper>
                        )}
                    </StyledWrapper>
                </StyledWrapper>
                <Modal
                    className="mobile-search-modal"
                    {...styles.mobileSearchModal}
                    isOpen={this.state.mobileSearchModalIsOpen}
                    closeOnEsc={true}
                    handleClose={this.mobileSearchModalCloseHandler}
                    // Starter Custom - moved SearchInput inside modal (headline)
                >
                    <SearchInput
                        id={id}
                        inputRef={this.mobileSearchInput}
                        // Starter Removed  - autocompletePositionFunction
                        onBeforeGoToUrl={this.mobileSearchModalCloseHandler}
                        extendedStyles={styles.mobileSearchInputStyles}
                    />
                </Modal>
            </StyledWrapper>
        );
    }
}

MainNavigation.contextType = StylesContext;

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const mainNavigation: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MainNavigation),
    definition: {
        group: "Header",
        icon: "magnifying-glass",
        allowedContexts: ["Header"],
        fieldDefinitions: [
            {
                name: fields.links,
                editorTemplate: "ListField",
                onEditRow: (index: number, dispatch) => {
                    dispatch({
                        type: "SendToSite/OpenMainNavigation",
                        index,
                    });
                },
                onDoneEditingRow: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                onLoad: dispatch => {
                    dispatch({
                        type: "SendToSite/CloseMainNavigation",
                    });
                },
                getDisplay: (item: HasFields, state) => {
                    const { type: typeValue, value: destinationValue } = item.fields.destination;
                    const { overrideTitle, title, linkType, parentTitle, titleLink } = item.fields;
                    let value = destinationValue;
                    let type = typeValue;
                    if (linkType === "CustomLinkList") {
                        if (parentTitle) {
                            return parentTitle;
                        }
                        type = titleLink.type;
                        value = titleLink.value;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return overrideTitle || link?.title;
                    }
                    if (type === "Category") {
                        if (overrideTitle) {
                            return overrideTitle;
                        }
                        if (value === emptyGuid) {
                            return "Products";
                        }
                        const categoryState = getCategoryState(state, value);
                        if (!categoryState.value) {
                            if (!categoryState.isLoading && value) {
                                return dispatch => {
                                    dispatch(
                                        loadCategory({
                                            id: value,
                                        }),
                                    );
                                };
                            }
                            return "";
                        }
                        return categoryState.value.shortDescription;
                    }
                    if (type === "Url") {
                        return title ?? value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "linkType",
                        editorTemplate: "RadioButtonsField",
                        defaultValue: "Link",
                        isRequired: true,
                        options: [
                            {
                                displayName: "Link",
                                value: "Link",
                            },
                            {
                                displayName: "Mega Menu",
                                value: "MegaMenu",
                            },
                            {
                                displayName: "Cascading Menu",
                                value: "CascadingMenu",
                            },
                            {
                                displayName: "Custom Link List",
                                value: "CustomLinkList",
                            },
                        ],
                    },
                    {
                        name: "overrideTitle",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item =>
                            item.fields.destination.type !== "Url" && item.fields.linkType !== "CustomLinkList",
                    },
                    /* Starter Custom Code - Start */
                    {
                        name: "isMegaMenuWithTabs",
                        displayName: "Display Main Child In Tabs",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        tooltip: "Will have a better display with at least 3 categories levels",
                        tooltipPosition: "left",
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "useOnHover",
                        displayName: "Menu opens on over",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        tooltip: "Menu opens on mouse over if true. Default is on click.",
                        tooltipPosition: "left",
                        isVisible: (item: HasFields) => item.fields.linkType !== "Link",
                    },
                    /* Starter Custom Code - End */
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                        allowUrls: item => item.fields.linkType === "Link",
                        showCategoryRoot: item => true,
                        isVisible: item => item.fields.linkType !== "CustomLinkList",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.destination.type === "Url",
                    },
                    {
                        name: "parentTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        isVisible: item => item.fields.linkType === "CustomLinkList",
                        validate: (value, item) => {
                            if (!value && item.fields.titleLink.value === "") {
                                return TS("Either Title or Destination must have a value");
                            }

                            if (!value && item.fields.titleLink.type === "Url") {
                                return TS("URLs must have a corresponding title");
                            }

                            return null;
                        },
                    },
                    {
                        name: "titleLink",
                        displayName: "Destination",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        isVisible: item => item.fields.linkType === "CustomLinkList",
                    },
                    {
                        name: "childLinks",
                        editorTemplate: "ListField",
                        getDisplay: (item: HasFields, state) => {
                            const {
                                destination: { type, value },
                                overrideTitle,
                            } = item.fields;
                            if (overrideTitle) {
                                return overrideTitle;
                            }
                            if (type === "Page") {
                                const link = getPageLinkByNodeId(state, value);
                                return link?.title;
                            }
                            if (type === "Category") {
                                let displayValue = "";
                                const { categories } = (state as any).pageEditor;
                                if (!categories) {
                                    displayValue = "Loading...";
                                } else {
                                    const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                                    if (matchingCategories.length === 0) {
                                        displayValue = "Unknown";
                                    } else {
                                        displayValue = matchingCategories[0].shortDescription;
                                    }
                                }

                                return displayValue;
                            }
                            if (type === "Url") {
                                return value;
                            }
                            return value;
                        },
                        defaultValue: [],
                        fieldDefinitions: [
                            {
                                name: "destination",
                                editorTemplate: "LinkField",
                                defaultValue: {
                                    value: "",
                                    type: "Page",
                                },
                                isRequired: true,
                            },
                            {
                                name: "overrideTitle",
                                editorTemplate: "TextField",
                                defaultValue: "",
                            },
                            {
                                name: "openInNewWindow",
                                editorTemplate: "CheckboxField",
                                defaultValue: false,
                            },
                        ],
                        isVisible: item => item.fields.linkType === "CustomLinkList",
                    },
                    /* Starter Custom Code - Start */
                    {
                        name: "numberOfColumns",
                        editorTemplate: "DropDownField",
                        defaultValue: 4, // Starter Custom Code
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }, { value: 6 }],
                        isRequired: true,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "MegaMenu" && !item.fields.isMegaMenuWithTabs, // Starter Custom Code
                    },
                    {
                        name: "numberOfColumnsMegaMenuWithTabs",
                        displayName: "Number of Columns",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) =>
                            item.fields.linkType === "MegaMenu" && item.fields.isMegaMenuWithTabs,
                    },
                    /* Starter Custom Code - End */
                    {
                        name: "maxDepth",
                        editorTemplate: "DropDownField",
                        defaultValue: 3,
                        options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }],
                        isRequired: true,
                        isVisible: (item: HasFields) => item.fields.linkType === "CascadingMenu",
                    },
                    /* Starter Custom Code - Start */
                    {
                        name: "maxChild",
                        editorTemplate: "IntegerField",
                        defaultValue: null,
                        min: 1,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "maxChildren",
                        editorTemplate: "IntegerField",
                        defaultValue: 3,
                        min: 1,
                        isVisible: (item: HasFields) => item.fields.linkType === "MegaMenu",
                    },
                    {
                        name: "maxGrandChildren",
                        editorTemplate: "IntegerField",
                        defaultValue: 3,
                        min: 1,
                        isVisible: (item: HasFields) => item.fields.isMegaMenuWithTabs === true,
                    },
                    /* Starter Custom Code - End */
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                        isVisible: (item: HasFields) => item.fields.linkType === "Link",
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.showQuickOrder,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: basicTab,
            },
            /* Starter Removed - openParentPages */
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default mainNavigation;
